import React, { useState } from 'react';
import { FaPhoneVolume, FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);

  // Fonction pour scroller vers une section en douceur
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setNavOpen(false); // Fermer le menu mobile après le clic
    }
  };

  return (
    <section className='w-full h-[80px] z-50 text-black bg-white fixed shadow-md'>
      <div className='container mx-auto px-4 flex justify-between items-center w-full h-full'>
        {/* Logo */}
        <button
          onClick={() => scrollToSection('accueil')}
          className='text-xl font-bold cursor-pointer'
        >
          QUAISDANROC
        </button>

        {/* Menu Desktop */}
        <div className='hidden md:flex items-center'>
          <ul className='flex space-x-6'>
            <li>
              <button
                onClick={() => scrollToSection('accueil')}
                className='hover:text-cyan-500 transition'
              >
                Accueil
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('services')}
                className='hover:text-cyan-500 transition'
              >
                Services
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('apropos')}
                className='hover:text-cyan-500 transition'
              >
                À propos
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('travaux')}
                className='hover:text-cyan-500 transition'
              >
                Nos Travaux
              </button>
            </li>
          </ul>
        </div>

        {/* Contact - Desktop */}
        <div className='hidden md:flex items-center'>
          <a
            href="tel:8198225760"
            className='flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg transition'
          >
            <FaPhoneVolume className='mr-2' />
            <span className='font-bold'>(819)822-5760</span>
          </a>
        </div>

        {/* Bouton Menu Mobile */}
        <button
          className='md:hidden text-2xl focus:outline-none'
          onClick={() => setNavOpen(!navOpen)}
        >
          {navOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Menu Mobile */}
      <div className={`md:hidden bg-white fixed w-full top-[80px] left-0 right-0 shadow-lg transition-all duration-300 ease-in-out ${navOpen ? 'block' : 'hidden'}`}>
        <ul className='flex flex-col space-y-4 p-4'>
          <li>
            <button
              onClick={() => scrollToSection('accueil')}
              className='block py-2 hover:text-cyan-500 transition w-full text-left'
            >
              Accueil
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('services')}
              className='block py-2 hover:text-cyan-500 transition w-full text-left'
            >
              Services
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('apropos')}
              className='block py-2 hover:text-cyan-500 transition w-full text-left'
            >
              À propos
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('travaux')}
              className='block py-2 hover:text-cyan-500 transition w-full text-left'
            >
              Nos Travaux
            </button>
          </li>
          <li>
            <a
              href="tel:8198225760"
              className='flex items-center justify-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-3 rounded-lg transition mt-2 w-full'
            >
              <FaPhoneVolume className='mr-2' />
              <span className='font-bold'>(819) 822-5760</span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Navbar;